import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { ProductsService } from 'shared-data-access';

@Injectable()
export class TenantIdInterceptor implements HttpInterceptor {
  private productsService = inject(ProductsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const effectiveTenantId: string = this.productsService.tenantId;

    if (effectiveTenantId) {
      const request: HttpRequest<unknown> = req.clone({
        setHeaders: {
          effectiveTenantId,
        },
      });
      return next.handle(request);
    }

    return next.handle(req);
  }
}
